import moment from 'moment-timezone';
import constants from 'components/common/Constants/constants';
import { IVersion } from 'api/queries/getProjectVersionsList.query';

export const getInitialExportName = (currentVersion: IVersion | null, simulationDate: number): string => {
    const sourceName =
        currentVersion === null ? '' : currentVersion.sourceFile.slice(0, (currentVersion.fileType.length + 1) * -1);
    return `${sourceName}.post-sim.${moment(simulationDate).format(constants.formats.date.default)}`;
};
